// Guest DTOs — PRD §3.9. Identity numbers travel only through dedicated endpoints and are masked by default.
import { z } from 'zod';
import { dateSchema, uuidSchema } from './common.js';
export const guestInputSchema = z
    .object({
    fullNameAr: z.string().trim().min(2).max(120).nullable().optional(),
    fullNameLatin: z.string().trim().min(2).max(120).nullable().optional(),
    gender: z.enum(['male', 'female', 'other']).nullable().optional(),
    dateOfBirth: dateSchema.nullable().optional(),
    nationality: z
        .string()
        .regex(/^[A-Z]{2}$/)
        .nullable()
        .optional(),
    phone: z
        .string()
        .trim()
        .regex(/^\+?[0-9]{6,15}$/)
        .nullable()
        .optional(),
    email: z.email().nullable().optional(),
    address: z.record(z.string(), z.string()).nullable().optional(),
    preferredLocale: z.enum(['ar', 'en']).default('ar'),
    notes: z.string().max(2000).nullable().optional(),
    vipLevel: z.number().int().min(0).max(5).default(0),
    marketingConsent: z.boolean().default(false),
    dataProcessingConsent: z.boolean().default(false),
})
    .refine((g) => g.fullNameAr || g.fullNameLatin, 'at least one name is required');
export const identityDocumentInputSchema = z.object({
    docType: z.enum(['passport', 'national_id', 'driving_license', 'residence_permit', 'other']),
    number: z.string().trim().min(3).max(40),
    issuingCountry: z
        .string()
        .regex(/^[A-Z]{2}$/)
        .nullable()
        .optional(),
    issueDate: dateSchema.nullable().optional(),
    expiryDate: dateSchema.nullable().optional(),
    extra: z.record(z.string(), z.string()).default({}),
});
export const blacklistPatchSchema = z.object({
    blacklisted: z.boolean(),
    reason: z.string().trim().min(3).max(300).optional(),
});
/** 09 §10.4: delete = anonymise; a legal retention floor schedules it instead (SEC-30) */
export const anonymizeGuestSchema = z.object({
    reason: z.string().trim().min(3).max(500),
});
export const mergeGuestsSchema = z.object({
    survivorId: uuidSchema,
    mergedId: uuidSchema,
});
export const guestSearchSchema = z.object({
    q: z.string().trim().min(1).max(80).optional(),
    phone: z.string().trim().max(20).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(20),
});
//# sourceMappingURL=guest.js.map